import React, { useState, useContext, useEffect } from "react";
import firebase from "firebase";
import { Link, useHistory } from "react-router-dom";
import { AudioContext } from "../../contexts/AudioContext";
import { AuthContext } from "../../Auth";
import "./style.scss";

const Profile = () => {
  const audioContext = useContext(AudioContext);
  const authContext = useContext(AuthContext);
  const [width, setWidth] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [score, setScore] = useState(0);
  const [lastScore, setLastScore] = useState(0);
  const [lastStatus, setLastStatus] = useState("");
  const [timeLeft, setTimeLeft] = useState(0);
  const [photoURL, setPhoto] = useState("");
  const [hms, setHMS] = useState("00:00:00");
  const loading = new Audio(require("../../assets/audio/loading.mp3"));
  const db = firebase.firestore();
  const history = useHistory();
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions());

    setLoading(true);
    audioContext.volumeDown();
    loading.volume = 0.5;
    loading.loop = true;
    loading.play();

    if (localStorage.email) {
      db.collection("users")
        .doc(localStorage.email)
        .get()
        .then((doc) => {
          localStorage.photo = doc.data().photo;
          localStorage.notify = doc.data().notify;
          setScore(doc.data().score);
          setLastScore(doc.data().lastScore);
          setLastStatus(doc.data().lastStatus);
          if (doc.data().timeLeft) {
            setLoading(false);
            setTimeLeft(doc.data().timeLeft);
            setPhoto(doc.data().photo);
            loading.pause();
            loading.currentTime = 0;
            audioContext.volumeUp();
            msToHMS(doc.data().timeLeft);
          } else {
            setLoading(false);
            setTimeLeft(0);
            setPhoto(doc.data().photo);
            loading.pause();
            loading.currentTime = 0;
            audioContext.volumeUp();
          }
        });
    } else {
      history.push("/signin");
    }

    return () => {
      window.removeEventListener("resize", updateWindowDimensions());
    };
  }, []);

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth);
  };

  const splitScore = (value) => {
    const integer = parseInt(value / 1);
    const decimal = parseFloat(value - integer).toFixed(3) * 1000;
    const score = [integer, decimal];
    return score;
  };

  const msToHMS = (timeLeft) => {
    let seconds = timeLeft / 1000;
    let hours = parseInt(seconds / 3600);
    seconds = seconds % 3600;
    let minutes = parseInt(seconds / 60);
    seconds = Math.floor(seconds % 60);
    const interval = setInterval(() => {
      if (hours === 0 && minutes === 0 && seconds === 0) {
        clearInterval(interval);
        setTimeLeft(0);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          hours--;
          minutes = 60;
        }
        minutes--;
        seconds = 60;
      }
      seconds--;
      const fHours = String(hours).padStart(2, "0");
      const fMinutes = String(minutes).padStart(2, "0");
      const fSeconds = String(seconds).padStart(2, "0");
      setHMS(fHours + ":" + fMinutes + ":" + fSeconds);
    }, 1000);
  };

  const handleClickStart = () => {
    const elem = document.getElementById("root");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="loader-container">
          <img
            alt="loader"
            src={require(`../../assets/images/SVG/1.svg`)}
            className="loader"
          ></img>
          <div>LOADING PROFILE SCREEN...</div>
        </div>
      ) : (
        ""
      )}
      <div
        className="profile"
        style={isLoading ? { opacity: 0 } : { opacity: 1 }}
      >
        {authContext.currentUser ? (
          <>
            <div className="profile-header">
              <div className="profile-header-group">
                <div className="profile-header-group-photo">
                  <img
                    alt="profile"
                    className="profile-header-group-photo-image"
                    src={photoURL}
                  ></img>
                </div>
                <Link
                  to="/profile/edit"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    zIndex: "1",
                  }}
                >
                  <div className="profile-header-group-edit">
                    <img
                      alt="edit"
                      src={require("../../assets/images/edit.svg")}
                    ></img>
                    <div>edit</div>
                  </div>
                </Link>
              </div>
              <div className="profile-header-name">{localStorage.nickName}</div>
            </div>
            <div className="profile-body" style={{ width: width - 40 }}>
              <div className="profile-body-score">
                <div className="profile-body-score-bestscore">
                  <div className="profile-body-score-bestscore-comment">
                    My Weekly Best
                  </div>
                  <div className="profile-body-score-bestscore-integer">
                    {splitScore(score)[0]}
                  </div>
                  <div className="profile-body-score-bestscore-decimal">
                    +{splitScore(score)[1]}
                  </div>
                  <div>milliseconds</div>
                </div>
                <img
                  alt="logo"
                  src={require("../../assets/images/logo.svg")}
                ></img>
                <div className="profile-body-score-lastscore">
                  <div className="profile-body-score-lastscore-comment">
                    Last Played Score
                  </div>
                  <div className="profile-body-score-lastscore-integer">
                    {splitScore(lastScore)[0]}
                  </div>
                  <div className="profile-body-score-lastscore-decimal">
                    +{splitScore(lastScore)[1]}
                  </div>
                  <div>milliseconds</div>
                </div>
              </div>
              <div className="profile-status">
                <div className="profile-status-comment">
                  Your current status:
                </div>
                {timeLeft > 0 ? (
                  <>
                    <div className="profile-status-text">
                      {lastStatus.toUpperCase()}
                    </div>
                    <img
                      alt="luck"
                      className="profile-status-image"
                      src={
                        lastStatus === "unlucky"
                          ? require("../../assets/images/unluck.svg")
                          : require("../../assets/images/luck.svg")
                      }
                    ></img>
                  </>
                ) : (
                  <>
                    <div className="profile-status-text">UNKNOWN</div>
                    <div style={{ fontSize: "14px" }}>
                      (play game to find out)
                    </div>
                  </>
                )}
              </div>
              {timeLeft <= 0 ? (
                <div className="profile-body-btns">
                  <Link to={{ pathname: "/luckygame" }}>
                    <button
                      className="profile-body-btns-start"
                      onClick={handleClickStart}
                    >
                      START GAME
                    </button>
                  </Link>
                  <p>You can test your luck right now!</p>
                  {/* <Link to="/challenge" style={{ textDecoration: "none" }}>
                  <button className="profile-body-challenge_button">
                    CHALLENGE FRIENDS
                    <img
                      alt="facebook"
                      src={require("../../assets/images/facebook.svg")}
                    ></img>
                  </button>
                </Link>
                <p>Challenge friends to beat your next score!</p> */}
                </div>
              ) : (
                <div className="profile-body-notify">
                  <div className="profile-body-notify-timer">
                    <img
                      alt="clock"
                      src={require("./../../assets/images/clock.svg")}
                    ></img>
                    <div className="profile-body-notify-timer-clock">{hms}</div>
                    {/* <div className="profile-body-notify-timer-start">
                    START GAME
                  </div> */}
                  </div>
                  <p>You can test your luck once per hour.</p>
                  {/* <Link to="/challenge" style={{ textDecoration: "none" }}>
                  <button className="profile-body-challenge_button">
                    CHALLENGE FRIENDS
                    <img
                      alt="facebook"
                      src={require("../../assets/images/facebook.svg")}
                    ></img>
                  </button>
                </Link> */}
                  {/* <p>Challenge friends to beat your next score!</p>
                {this.state.notify ? (
                  <button
                    className="profile-body-notify-button-on"
                    disabled={true}
                  >
                    NOTIFICATIONS ON
                  </button>
                ) : (
                  <button
                    className="profile-body-notify-button"
                    onClick={this.handleClickNotify}
                  >
                    NOTIFY ME
                  </button>
                )} */}
                  {/* <p>
                  We will send you notification when you can play again.
                </p> */}
                </div>
              )}
            </div>
          </>
        ) : (
          // <>
          //   <div className="profile-header">
          //     <div className="profile-header-group">
          //       <img
          //         alt="luck"
          //         className="profile-header-group-luck"
          //         src={
          //           this.state.lastStatus === "unlucky"
          //             ? require("../../assets/images/unluck.svg")
          //             : require("../../assets/images/luck.svg")
          //         }
          //       ></img>
          //       <div className="profile-header-group-photo">
          //         <img
          //           alt="profile"
          //           className="profile-header-group-photo-image"
          //           src={require("../../assets/images/0.svg")}
          //         ></img>
          //       </div>
          //       <Link
          //         to="/profile/edit"
          //         style={{ textDecoration: "none", color: "white" }}
          //       >
          //         <div className="profile-header-group-edit">
          //           <img
          //             alt="edit"
          //             src={require("../../assets/images/edit.svg")}
          //           ></img>
          //           <div>edit</div>
          //         </div>
          //       </Link>
          //     </div>
          //     <div className="profile-header-name">{"GUEST"}</div>
          //   </div>
          //   <div
          //     className="profile-body"
          //     style={{ width: this.state.width - 40 }}
          //   >
          //     <div className="profile-body-score">
          //       <div className="profile-body-score-bestscore">
          //         <div className="profile-body-score-bestscore-comment">
          //           My Weekly Best
          //         </div>
          //         <div className="profile-body-score-bestscore-integer">
          //           {this.splitScore(this.state.score)[0]}
          //         </div>
          //         <div className="profile-body-score-bestscore-decimal">
          //           +{this.splitScore(this.state.score)[1]}
          //         </div>
          //         <div>milliseconds</div>
          //       </div>
          //       <img
          //         alt="logo"
          //         src={require("../../assets/images/logo.svg")}
          //       ></img>
          //       <div className="profile-body-score-lastscore">
          //         <div className="profile-body-score-lastscore-comment">
          //           Last Played Score
          //         </div>
          //         <div className="profile-body-score-lastscore-integer">
          //           {this.splitScore(localStorage.getItem("guestScore"))[0]}
          //         </div>
          //         <div className="profile-body-score-lastscore-decimal">
          //           +{this.splitScore(localStorage.getItem("guestScore"))[1]}
          //         </div>
          //         <div>milliseconds</div>
          //       </div>
          //     </div>
          //   </div>
          //   <div className="profile-footer">
          //     <div className="profile-footer-test">
          //       <Link to="/guest">
          //         <button
          //           className="profile-footer-test-button"
          //           onClick={this.handleCLickTest}
          //         >
          //           TEST LUCK
          //         </button>
          //       </Link>
          //       <div>You can test your luck once per hour.</div>
          //     </div>
          //     <div className="profile-footer-challenge">
          //       <Link to="/challenge" style={{ textDecoration: "none" }}>
          //         <button className="profile-footer-challenge-button">
          //           CHALLENGE FRIENDS
          //           <img
          //             alt="facebook"
          //             src={require("../../assets/images/facebook.svg")}
          //           ></img>
          //         </button>
          //       </Link>
          //       <div>Facebook friends will have to beat your score!</div>
          //     </div>
          //   </div>
          // </>
          <>
            <div className="profile-comment">You didn't Sign In!</div>
            <Link to="/signin">
              <button className="profile-button">Sign In</button>
            </Link>
          </>
        )}
      </div>
    </>
  );
};

export default Profile;
